import { FC } from 'react';
import EditorialModuleArticles from 'dibs-editorial-module/exports/EditorialModuleArticles';
import { createFragmentContainer, graphql } from 'react-relay';
import { PdpSharedEditorialArticles_item } from './__generated__/PdpSharedEditorialArticles_item.graphql';
import styles from './PdpSharedEditorialArticles.scss';

type Props = {
    item: PdpSharedEditorialArticles_item;
};

const NUM_EDITORIAL_ARTICLES = 2;

const PdpSharedEditorialArticlesComponent: FC<Props> = ({ item }) => {
    const articles =
        item?.storyTellingModule?.tabs?.[0]?.supplementaryEditorial?.articles?.slice(
            0,
            NUM_EDITORIAL_ARTICLES
        ) || [];
    return articles.length ? (
        <div className={styles.container}>
            <EditorialModuleArticles articles={articles} useWhiteBg />
        </div>
    ) : null;
};

export const PdpSharedEditorialArticles = createFragmentContainer(
    PdpSharedEditorialArticlesComponent,
    {
        item: graphql`
            fragment PdpSharedEditorialArticles_item on Item {
                storyTellingModule {
                    tabs {
                        supplementaryEditorial {
                            articles {
                                ...EditorialModuleArticles_articles
                            }
                        }
                    }
                }
            }
        `,
    }
);
